import { ChartField } from 'src/app/types/chart.model'
import { NUM_MATCHED_ITEMS_VALUE_FIELD } from 'src/app/types/constants'
import { CHILD_JOB_FIELDS } from './job-lookup.model'

export interface ProcessedClaim {
  id: number

  jobNumber: string | null

  invoiceDate: Date
  dueDate: Date
  createDate: Date
  postedDate: Date

  totalExGST: number
  totalIncGST: number
  totalGST: number

  jobId: number
  type: string
  status: string
  division: string | null
  stage: string | null
  siteManager: string | null
}

export const CLAIM_ALL_FIELDS: ChartField[] = [
  {
    dataField: 'invoiceDate',
    displayName: 'Invoice Date',
    dataType: 'date',
  },
  {
    dataField: 'dueDate',
    displayName: 'Due Date',
    dataType: 'date',
  },
  {
    // Income invoices are created when they are posted, so createDate is the posted date.
    dataField: 'createDate',
    displayName: 'Posted Date',
    dataType: 'date',
  },
  {
    dataField: 'type',
    displayName: 'Type',
    dataType: 'string',
  },
  {
    dataField: 'status',
    displayName: 'Status',
    dataType: 'string',
  },
  {
    dataField: 'totalIncGST',
    displayName: 'Total Inc GST',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'totalExGST',
    displayName: 'Total Ex GST',
    dataType: 'number',
    numberPrefix: '$',
  },
  {
    dataField: 'totalGST',
    displayName: 'Total GST',
    dataType: 'number',
    numberPrefix: '$',
  },
  ...CHILD_JOB_FIELDS,
]

export const CLAIM_FILTER_FIELDS: ChartField[] = CLAIM_ALL_FIELDS

export const CLAIM_DATE_FILTER_FIELDS: ChartField[] = CLAIM_ALL_FIELDS.filter(
  (field) => field.dataType === 'date'
)

export const CLAIM_ARGUMENT_FIELDS: ChartField[] = CLAIM_ALL_FIELDS.filter(
  (field) => field.dataType !== 'number'
)

export const CLAIM_VALUE_FIELDS: ChartField[] = [NUM_MATCHED_ITEMS_VALUE_FIELD].concat(
  CLAIM_ALL_FIELDS.filter((field) => field.dataType === 'number')
)

export const CLAIM_SERIES_GROUP_FIELDS: ChartField[] = CLAIM_ALL_FIELDS.filter(
  (field) => field.dataType === 'string' || field.dataType === 'boolean'
)
